export default __webpack_public_path__ + "static/emails-joy-0822d77d5dd19355b90d51532dca270e.gif";